export enum FormKey {
  CAPTCHA = 'captcha',
  COMPANY_NAME = 'companyName',
  COMPANY_SIZE = 'companySize',
  COUNTRY = 'country',
  FULL_NAME = 'fullName',
  PASSWORD = 'password',
  PHONE_NUMBER = 'phoneNumber',
  POSITION_TITLE = 'positionTitle',
  SOURCE = 'source',
  TERMS_OF_USE = 'termsOfUse',
  WORK_EMAIL = 'workEmail',
}
